import React from "react";
import { Translate } from "components/common/Translate/Translate";
import { FAQScaffold, IFaq } from "components/features/CompressorCommon/FAQScaffold";

const faqAsList: IFaq[] = [
    {
        question: "gif-compressor-faq-why-use-question",
        answer: "gif-compressor-faq-why-use-ans",
    },
    {
        question: "gif-compressor-faq-discord-question",
        answer: "gif-compressor-faq-discord-ans",
    },
    {
        question: "gif-compressor-faq-best-free-question",
        answer: "gif-compressor-faq-best-free-ans",
    },
    {
        question: "gif-compressor-faq-reduce-size-question",
        answer: "gif-compressor-faq-reduce-size-ans",
    },
    {
        question: "gif-compressor-faq-settings-question",
        answer: "gif-compressor-faq-settings-ans",
    },

    {
        question: "gif-compressor-faq-compression-level-question",
        answer: "gif-compressor-faq-compression-level-ans",
    },
    {
        question: "gif-compressor-faq-do-you-support-other-image-compressions-as-well-question",
        answer: "gif-compressor-faq-do-you-support-other-image-compressions-as-well-ans",
    },
    {
        question: "compressor-faq-clipsnap-image-upscaler-question",
        answer: "compressor-faq-clipsnap-image-upscaler-answer",
    },
    {
        question: "compressor-faq-clipsnap-bg-remover-question",
        answer: "compressor-faq-clipsnap-bg-remover-answer",
    },
];

const GifCompressorFaq = () => {
    return (
        <FAQScaffold
            faqAsList={faqAsList}
            sectionTitle={<Translate keyName="gif-compressor-faq-title" />}
            sectionSubTitle={<Translate keyName="gif-compressor-faq-sub-title" />}
        />
    );
};

export default GifCompressorFaq;
